import { TFunction } from 'i18next';

export function getAccountDrawerConfig(t: TFunction<any, any>) {
  return [
    // { label: t("pages.titles.profile"), href: paths.dashboard.profile, icon: <Iconify icon="solar:user-circle-bold-duotone" /> },
    // { label: t("pages.titles.security"), href: paths.dashboard.security, icon: <Iconify icon="solar:shield-keyhole-bold-duotone" /> },
    // { label: t("pages.titles.settings"), href: paths.dashboard.settings, icon: <Iconify icon="solar:settings-bold-duotone" /> },
  ];
}
